<div class="container" role="main">
  <section class="hero-banner">
    <img
      class="hero-banner__image"
      src="assets/img/story-cnh/hero-banner.png"
      [alt]="'STORY.HERO_ALT' | translate"
    />
  </section>

  <section class="story-wrapper">
    <div class="story-section">
      <div class="story-section__content">
        <h2 tabindex="0">{{ 'STORY.SECTION1_TITLE' | translate }}</h2>
        <p tabindex="0">{{ 'STORY.SECTION1_DESC' | translate }}</p>
      </div>
      <div class="story-section__image">
        <img src="assets/img/story-cnh/section-1.jpg" [alt]="'STORY.SECTION1_TITLE' | translate" />
      </div>
    </div>

    <div class="story-section reverse">
      <div class="story-section__content">
        <h2 tabindex="0">{{ 'STORY.SECTION2_TITLE' | translate }}</h2>
        <p tabindex="0">{{ 'STORY.SECTION2_DESC' | translate }}</p>
      </div>
      <div class="story-section__image">
        <img src="assets/img/story-cnh/section-2.png" [alt]="'STORY.SECTION2_TITLE' | translate" />
      </div>
    </div>

    <div class="story-section">
      <div class="story-section__content">
        <h2 tabindex="0">{{ 'STORY.SECTION3_TITLE' | translate }}</h2>
        <p tabindex="0">{{ 'STORY.SECTION3_DESC' | translate }}</p>
      </div>
      <div class="story-section__image">
        <img src="assets/img/story-cnh/section-3.jpg" [alt]="'STORY.SECTION3_TITLE' | translate" />
      </div>
    </div>

    <div class="story-section reverse">
      <div class="story-section__content">
        <h2 tabindex="0">{{ 'STORY.SECTION4_TITLE' | translate }}</h2>
        <p tabindex="0">{{ 'STORY.SECTION4_DESC' | translate }}</p>
      </div>
      <div class="story-section__image">
        <img src="assets/img/story-cnh/section-4.jpg" [alt]="'STORY.SECTION4_TITLE' | translate" />
      </div>
    </div>
  </section>

  <section class="story-cta">
    <h2 tabindex="0">{{ 'STORY.CTA_TITLE' | translate }}</h2>
    <p tabindex="0">{{ 'STORY.CTA_DESC' | translate }}</p>

    <a 
      (click)="goHomeAndScrollTop()" 
      class="story-cta__btn"
      role="button"
      [attr.aria-label]="'STORY.CTA_BTN' | translate"
    > 
      {{ 'STORY.CTA_BTN' | translate }} 
    </a>
  </section>
</div>